import { render, staticRenderFns } from "./platformPayList.vue?vue&type=template&id=55e83523&scoped=true&"
import script from "./platformPayList.vue?vue&type=script&lang=js&"
export * from "./platformPayList.vue?vue&type=script&lang=js&"
import style0 from "./platformPayList.vue?vue&type=style&index=0&id=55e83523&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e83523",
  null
  
)

export default component.exports